/** @jsxImportSource @emotion/react */

import { memo } from "react";

import { ButtonProps, Button as ButtonComp, CircularProgress } from "@material-ui/core";

import { Icon } from "..";

import { btn, whiteColor, errorColor } from "./styles";

export interface Props extends Omit<ButtonProps, "color"> {
  icon?: string;
  color?: "inherit" | "default" | "primary" | "secondary" | "error" | "white";
  loading?: boolean;
  [k: string]: any;
}

const Button = ({ children, icon, color, startIcon, loading = false, ...rest }: Props): JSX.Element => (
  <ButtonComp
    css={[btn, color === "white" && whiteColor, color === "error" && errorColor]}
    startIcon={loading ? <CircularProgress color="secondary" size={16} /> : startIcon || (icon && <Icon name={icon} />)}
    color={color === "error" || color === "white" ? undefined : color}
    disableElevation
    {...rest}
  >
    {children}
  </ButtonComp>
);

export default memo(Button);
